import { DateMetaData } from "burde";
import * as moment from "moment";
import { Moment } from "moment";
import { D3Selection } from "svg/draw/draw-calendar";
import { CalendarSizeDimensions } from "svg/constants";
import * as yearOverviewLeft from "svg/year-overview/year-overview-left.svg";
import * as yearOverviewRight from "svg/year-overview/year-overview-right.svg";
import drawDynamicMonthModule from "./draw-dynamic-month-module";
import { cultureCountries, DefaultCulture } from "ui/constants";

const drawDynamicYearOverview = (
    baseElement: D3Selection,
    isConfiguratorView: boolean,
    startDate: Moment,
    metaData: DateMetaData[],
    culture: string | null,
    calendarDimensions: CalendarSizeDimensions,
    calendarId: number | null,
    Header_WeekNumberPrefix: string,
    isLeftPage: boolean,
    customOrderId: string | null,
) => {
    const yearOverviewBaseElement = isConfiguratorView
        ? baseElement
        : baseElement.append("div").attr("class", "svg-container");

    const yearOverview = isLeftPage ? yearOverviewLeft : yearOverviewRight;

    let svg = yearOverviewBaseElement
        .append("svg")
        .attr("width", "100%")
        .attr("height", "100%")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true);

    svg.append("g")
        .html(<string>yearOverview)
        .select("svg")
        .attr("width", calendarDimensions.svgWidth)
        .attr("height", calendarDimensions.svgHeight)
        .attr("id");

    const yearContainer = svg.select("g").select("svg").select("g");

    const yearText = yearContainer.select(".year");
    yearText.text(startDate.format("YYYY"));

    const yearElements = yearContainer.selectAll("g");
    let iterationDate = moment(startDate, "YYYY-MM-DD").startOf("year");
    // Iterate through the seasons
    yearElements.each(function (d: unknown, i: number) {
        const monthElement = yearContainer.select(`.month${i + 1}`);

        drawDynamicMonthModule(
            monthElement,
            iterationDate,
            metaData,
            culture,
            Header_WeekNumberPrefix,
        );

        iterationDate = moment(
            iterationDate.clone().add(1, "month").format("YYYY-MM-DD"),
            "YYYY-MM-DD",
        );
    });

    const cultureCountry =
        culture !== null
            ? cultureCountries.find((x) => x.culture === culture)
            : cultureCountries.find((x) => x.culture === DefaultCulture);
    const countryPrefix =
        cultureCountry !== undefined ? cultureCountry.country : "";

    if (customOrderId !== null) {
        svg.append("text")
            .attr("x", "50%")
            .attr("y", calendarDimensions.yearOverviewIdHeight)
            .attr("font-size", "30px")
            .attr("font-family", "arial")
            .attr("fill", "gray")
            .attr("text-anchor", "middle")
            .text(customOrderId);
    } else if (calendarId !== null) {
        svg.append("text")
            .attr("x", "50%")
            .attr("y", calendarDimensions.yearOverviewIdHeight)
            .attr("font-size", "30px")
            .attr("font-family", "arial")
            .attr("fill", "gray")
            .attr("text-anchor", "middle")
            .text(`${countryPrefix}-${calendarId.toString()}`);
    }
};

export { drawDynamicYearOverview };
